import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/feature/SEOHead';

const articles = [
  {
    slug: '/blog/volet-roulant-ne-remonte-plus/',
    title: 'Volet roulant qui ne remonte plus : causes et solutions',
    excerpt: "Volet électrique ou manuel qui refuse de remonter ? Moteur, condensateur, sangle ou lames : voici les causes fréquentes, ce que vous pouvez vérifier vous-même et quand appeler un professionnel à Lyon.",
    image: "/images/dfpro-hero-2026.jpg", date: '2026-07-22', category: 'Volet roulant',
  },
  {
    slug: '/blog/volet-roulant-bloque-que-faire/',
    title: 'Volet roulant bloqué : que vérifier avant d\'appeler',
    excerpt: "Volet coincé à mi-course ou totalement bloqué ? Apprenez à localiser le blocage, les vérifications à faire sans rien casser et les cas où l'intervention d'un pro s'impose.",
    image: "/images/dfpro-hero-2026.jpg", date: '2026-07-23', category: 'Volet roulant',
  },
  {
    slug: '/blog/changer-sangle-volet-roulant/',
    title: 'Changer la sangle d\'un volet roulant : étapes et limites',
    excerpt: "Sangle usée, effilochée ou cassée ? Découvrez le principe du remplacement, les étapes, le matériel et les situations où mieux vaut confier la réparation à un professionnel.",
    image: "/images/dfpro-hero-2026.jpg", date: '2026-07-24', category: 'Volet roulant',
  },
  {
    slug: '/blog/moteur-volet-roulant-en-panne/',
    title: 'Moteur de volet roulant en panne : diagnostic',
    excerpt: "Volet qui bourdonne, ne répond plus ou s'arrête en route ? Condensateur, fins de course, télécommande ou moteur : ce que révèle chaque symptôme, toutes marques.",
    image: "/images/dfpro-hero-2026.jpg", date: '2026-07-25', category: 'Volet roulant',
  },
  {
    slug: '/blog/double-vitrage-embue/',
    title: 'Double vitrage embué : pourquoi et comment y remédier',
    excerpt: "De la buée entre les deux vitres, impossible à essuyer ? On vous explique pourquoi le vitrage n'est plus étanche, ce que ça change pour l'isolation et comment le remplacer.",
    image: "/images/vitrage-embue-hero-2026.jpg", date: '2026-07-21', category: 'Vitrage',
  },
  {
    slug: '/blog/fenetre-qui-ferme-mal/',
    title: 'Fenêtre qui ferme mal : crémone, réglage et solutions',
    excerpt: "Une fenêtre qui laisse passer l'air ? Crémone, dilatation, gonds : les causes fréquentes, ce qui se règle et ce qui se remplace pour retrouver une fermeture étanche.",
    image: "/images/dfpro-fenetre-bloquee-2026.webp", date: '2026-07-20', category: 'Fenêtre',
  },
  {
    slug: '/blog/baie-vitree-qui-coince/',
    title: 'Baie vitrée qui coince : roulettes, rail et réglage',
    excerpt: "Baie coulissante dure à ouvrir ou qui déraille ? Roulettes usées, rail encrassé, désalignement : les causes et les solutions pour un coulissement fluide.",
    image: "/images/dfpro-roulette-2026.jpg", date: '2026-07-19', category: 'Baie vitrée',
  },
  {
    slug: '/blog/moustiquaire-fenetre-sans-percage/',
    title: 'Moustiquaire de fenêtre sans perçage : quelle solution ?',
    excerpt: "Poser une moustiquaire sans percer, c'est possible. Cadre à clipser, enroulable, aimantée : comparez les solutions, leurs limites et l'intérêt d'une pose sur mesure.",
    image: "/images/dfpro-moust-fenetre-2026.jpg", date: '2026-07-18', category: 'Moustiquaire',
  },
  {
    slug: '/blog/cle-cassee-dans-serrure/',
    title: 'Clé cassée dans la serrure : que faire et qui appeler à Lyon',
    excerpt: "Votre clé vient de se casser dans le barillet de votre porte d'entrée ? Ne paniquez pas. Voici les gestes à adopter immédiatement, ce qu'il ne faut surtout pas faire, et comment un serrurier professionnel à Lyon peut vous sortir de cette situation en moins d'une heure.",
    image: "/images/blog-cle-cassee-2026.jpg",
    date: '2026-07-20',
    category: 'Serrurerie',
  },
  {
    slug: '/blog/porte-entree-qui-ferme-mal/',
    title: "Porte d'entrée qui ferme mal : causes et solutions à Lyon",
    excerpt: "Votre porte d'entrée frotte, coince ou ne se verrouille plus correctement ? Découvrez les causes les plus fréquentes de ce problème — du gond desserré à la dilatation thermique — et les solutions adaptées pour retrouver une porte fonctionnelle et sécurisée.",
    image: "/images/blog-porte-ferme-mal-2026.jpg",
    date: '2026-07-18',
    category: 'Porte',
  },
  {
    slug: '/blog/changer-serrure-appeler-pro/',
    title: 'Changer une serrure soi-même ou appeler un pro à Lyon ?',
    excerpt: "Vous envisagez de changer votre serrure vous-même pour économiser ? Avant de vous lancer, découvrez les pièges à éviter, les compétences nécessaires, et dans quels cas faire appel à un professionnel reste la solution la plus sûre et la plus économique à long terme.",
    image: "/images/blog-changer-serrure-pro-2026.avif",
    date: '2026-07-15',
    category: 'Serrurerie',
  },
];

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Blog',
  name: 'Le blog DFPRO Lyon — Conseils menuiserie et serrurerie',
  description: 'Articles et conseils pratiques sur la réparation et l\'entretien de vos menuiseries à Lyon : volets roulants, portes, fenêtres, stores, serrurerie et vitrerie.',
  url: 'https://depanfenetres-lyon.fr/blog/',
  blogPost: articles.map((a) => ({
    '@type': 'BlogPosting',
    headline: a.title,
    url: `https://depanfenetres-lyon.fr${a.slug}`,
    datePublished: a.date,
    image: a.image,
  })),
};

export default function BlogIndex() {
  const pageUrl = 'https://depanfenetres-lyon.fr/blog/';
  const title = 'Blog DFPRO Lyon | Conseils menuiserie, serrurerie et vitrerie';

  return (
    <>
      <SEOHead
        title={title}
        description="Retrouvez nos articles et conseils pratiques sur la réparation de menuiseries à Lyon : volets roulants, portes, serrures, fenêtres, stores, BSO et vitrerie."
        canonicalUrl={pageUrl}
        jsonLd={jsonLd}
      />
      <Header />

      <main>
        <section className="relative w-full min-h-[260px] md:min-h-[340px] flex items-center">
          <div className="absolute inset-0">
            <img
              src="/images/blog-index-hero-2026.webp"
              alt="Blog DFPRO Lyon — Conseils menuiserie et serrurerie"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-foreground-900/55 via-foreground-900/35 to-foreground-900/55"></div>
          </div>
          <div className="relative z-10 w-full px-4 md:px-6 py-12 md:py-16">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading font-bold text-xl md:text-3xl lg:text-4xl text-background-50 leading-tight">
                Le blog DFPRO Lyon
              </h1>
              <p className="mt-4 text-sm md:text-lg text-background-50/90 max-w-2xl mx-auto leading-relaxed">
                Conseils pratiques, astuces et guides pour l&apos;entretien et la réparation de vos menuiseries à Lyon et dans la métropole. Volets roulants, portes, serrures, fenêtres, stores, BSO et vitrerie : nos experts partagent leur savoir-faire.
              </p>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-3 border-b border-background-200">
          <div className="max-w-7xl mx-auto px-4 md:px-6">
            <nav className="flex items-center gap-1.5 text-xs md:text-sm flex-wrap whitespace-nowrap" aria-label="Fil d'ariane">
              <a href="/" className="text-secondary-500 hover:text-primary-500 transition-colors">Accueil</a>
              <span className="text-secondary-400">/</span>
              <span className="text-foreground-700 font-medium">Blog</span>
            </nav>
          </div>
        </section>

        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="max-w-5xl mx-auto px-4 md:px-6">
            <h2 className="font-heading font-bold text-lg md:text-2xl text-foreground-800 mb-8">Tous nos articles</h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <a
                  key={article.slug}
                  href={article.slug}
                  className="group bg-background-100 rounded-lg overflow-hidden transition-all duration-200 hover:scale-[1.02] cursor-pointer no-underline"
                >
                  <div className="w-full h-48 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 mb-2">
                      <span className="text-xs font-medium text-accent-500 bg-accent-50 px-2 py-0.5 rounded-full">{article.category}</span>
                      <span className="text-xs text-secondary-400">{article.date}</span>
                    </div>
                    <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-800 group-hover:text-primary-500 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-xs md:text-sm text-secondary-500 leading-relaxed line-clamp-3">
                      {article.excerpt}
                    </p>
                    <span className="inline-flex items-center gap-1 mt-3 text-xs font-medium text-primary-500 group-hover:text-primary-600 transition-colors">
                      Lire l&apos;article
                      <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center"></i>
                    </span>
                  </div>
                </a>
              ))}
            </div>

            <div className="mt-12 text-center">
              <p className="text-sm text-secondary-400">Plus d&apos;articles bientôt disponibles. Revenez nous voir !</p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}